import type { DrawdownRecord } from '../types'

/** A fall in R, signed: 3 → "−3.00R", 0 → "0.00R". */
const fallR = (r: number): string => (r > 0 ? `−${r.toFixed(2)}R` : '0.00R')

/**
 * "deepest fall −3.00R · longest losing run 3", or null with nothing measured.
 * Gross: the Track Record's own figures are before fees.
 */
export const drawdownLine = (d: DrawdownRecord | null | undefined): string | null => {
  if (!d || d.n === 0 || d.max_drawdown_r_gross == null) return null
  return `deepest fall ${fallR(d.max_drawdown_r_gross)} · longest losing run ${d.longest_losing_streak}`
}
